'use strict';
import LandingPageComponent from './landing-page.component';
import LandingPageContentComponent from './landing-page-content.component';

const landingPageComponentName = 'mxLandingPage';

export default angular
	.module('mx.sb.LandingPage', [])
	.run([
		'mx.shell.RoutingService',
		function (routingService) {
			const landingPageRoute = routingService.createRoutingItem({
				name: 'landingPage',
				path: '/landing-page/:navigationId',
				title: 'Landing_page',
				component: landingPageComponentName,
			});
			routingService.landingPageRoute = landingPageRoute;
			routingService.addItems([landingPageRoute]);
		},
	])
	.component(landingPageComponentName, LandingPageComponent)
	.component('mxCommonLandingPageContent', LandingPageContentComponent).name;
